export default __webpack_public_path__ + "static/media/iste2.35d7bf7d.png";